import React from 'react'

function TitleBox({ projecttitle }) {


    return (
        <section className='TitleBox-section'>



            <h1 className="Project-title top-2xl bottom-2xl"> {projecttitle} </h1>



        </section>
    )
}

export default TitleBox